// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enhanced Aside/Sidebar Styles */
li {
    list-style: none !important;
    text-decoration: none !important;
}

/* Basic nestedullistss styles */
.nestedullistss{
    padding-left: 25px;
    background-color: #2c3b41;
    padding-top: 2px;
    padding-bottom: 5px;
    display: none; /* Hidden by default */
    transition: all 0.3s ease;
}

/* Show class for dropdowns */
.nestedullistss.show {
    display: block !important;
}

.collapse.show {
    display: block !important;
}

.fa-circle-o{
    margin-right: 6px;
}

.nestedullistss li a,.nestedullistss li{
    font-size: 16px !important;
    color: rgb(101, 101, 101) ;
    margin-top: 9px;
    text-decoration: none !important;
}

.nestedullistss li a:hover{
    color: #fff ;
    text-decoration: none !important;
}

/* Enhanced dropdown arrow animation */
.sidebar-menu li > a .pull-right-container .fa-angle-left {
    transition: transform 0.3s ease;
}

.sidebar-menu li > a[aria-expanded="true"] .pull-right-container .fa-angle-left {
    transform: rotate(-90deg);
}`, "",{"version":3,"sources":["webpack://./src/Components/Css/Aside.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa,EAAE,sBAAsB;IACrC,yBAAyB;AAC7B;;AAEA,6BAA6B;AAC7B;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,gCAAgC;AACpC;;AAEA,sCAAsC;AACtC;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* Enhanced Aside/Sidebar Styles */\nli {\n    list-style: none !important;\n    text-decoration: none !important;\n}\n\n/* Basic nestedullistss styles */\n.nestedullistss{\n    padding-left: 25px;\n    background-color: #2c3b41;\n    padding-top: 2px;\n    padding-bottom: 5px;\n    display: none; /* Hidden by default */\n    transition: all 0.3s ease;\n}\n\n/* Show class for dropdowns */\n.nestedullistss.show {\n    display: block !important;\n}\n\n.collapse.show {\n    display: block !important;\n}\n\n.fa-circle-o{\n    margin-right: 6px;\n}\n\n.nestedullistss li a,.nestedullistss li{\n    font-size: 16px !important;\n    color: rgb(101, 101, 101) ;\n    margin-top: 9px;\n    text-decoration: none !important;\n}\n\n.nestedullistss li a:hover{\n    color: #fff ;\n    text-decoration: none !important;\n}\n\n/* Enhanced dropdown arrow animation */\n.sidebar-menu li > a .pull-right-container .fa-angle-left {\n    transition: transform 0.3s ease;\n}\n\n.sidebar-menu li > a[aria-expanded=\"true\"] .pull-right-container .fa-angle-left {\n    transform: rotate(-90deg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
